import { Link } from "react-router-dom";
import { formatDate } from "./useNewsItems";

// お知らせの1行（トップ・お知らせ一覧で共通）。外部（PR TIMES）は別タブで開く。
export default function NewsRow({ item }) {
  const inner = (
    <>
      <div className={`thumb${item.thumb ? "" : " placeholder"}`}>
        <img src={item.thumb || "/assets/icn_logo.svg"} alt="" loading="lazy" />
      </div>
      <div className="article-copy">
        <span className="date">{formatDate(item.date)}</span>
        <span className="news-cat">{item.cat}</span>
        <h4>{item.title}</h4>
        {item.excerpt && <p>{item.excerpt}</p>}
      </div>
    </>
  );
  if (item.href) {
    return (
      <a
        className="article-row"
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {inner}
      </a>
    );
  }
  return (
    <Link className="article-row" to={item.to}>
      {inner}
    </Link>
  );
}
